"use client";

import { useEffect } from "react";
import { initMixpanel } from "./mixpanel";
import { useInitializeAnalytics } from "./useInitializeAnalytics";

export function MixpanelInit() {
  useEffect(() => {
    initMixpanel(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? "");
  }, []);

  useInitializeAnalytics();

  return null;
}
